<nz-spin [nzSpinning]="isLoading">
  <div class="row pt-5 justify-content-center min-vh-100"></div>
</nz-spin>
